import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-65a95d10"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "standard3dList cont3d"
};
const _hoisted_2 = {
  key: 0,
  class: "logo"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "cont3d"
};
const _hoisted_5 = ["data-code", "data-autoCode"];
const _hoisted_6 = ["data-code", "data-autoCode"];
const _hoisted_7 = ["src", "data-code", "data-autoCode"];
const _hoisted_8 = ["data-code", "data-autoCode"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$data.config.logo ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("img", {
    src: $data.config.logo
  }, null, 8, _hoisted_3)])) : _createCommentVNode("", true), _createElementVNode("ul", _hoisted_4, [_createElementVNode("li", {
    class: "clearfix cont3dlist",
    ref: "list",
    onClick: _cache[0] || (_cache[0] = $event => $options.clickProps($event))
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.datas, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "Item3d",
      "data-code": item.code,
      "data-autoCode": item.autoCode
    }, [_createElementVNode("div", {
      class: _normalizeClass(["item", `scale${parseInt(Math.random() * 7)}`]),
      "data-code": item.code,
      "data-autoCode": item.autoCode
    }, [_createElementVNode("img", {
      src: item.img,
      "data-code": item.code,
      "data-autoCode": item.autoCode
    }, null, 8, _hoisted_7), _createElementVNode("span", {
      "data-code": item.code,
      "data-autoCode": item.autoCode
    }, _toDisplayString(item.name), 9, _hoisted_8)], 10, _hoisted_6)], 8, _hoisted_5);
  }), 256))], 512)])]);
}